import React from 'react';
import Button from 'react-bootstrap/Button';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'

function EditPendingReportButton(props) {

  const tooltip = (
    <Tooltip>Edit Premium Report</Tooltip>
  )

  return (
    <OverlayTrigger placement="top" overlay={tooltip}>
      <Button onClick={(e) => {
        // just let it pass through
      }} className="reportActionButton">
        <FontAwesomeIcon icon={solid("pen-to-square")} className="buttonIcon" />
      </Button>
    </OverlayTrigger>
  );
}

export default EditPendingReportButton;